import Logo from "./Logo";
import { __ } from "@wordpress/i18n";

export const AppHeader = ({ enableBrowseButton = false, enableSettingsButton = false ,style={}} = {}) => {
	return (
		<div style={{ paddingTop: "20px", paddingLeft: "20px",...style }}>
			<Logo enableBrowseButton={enableBrowseButton} enableSettingsButton={enableSettingsButton} />
			<p
				style={{ marginBottom: 0 }}
				className="image-hub-text-under-logo"
			>
				{__("Search and insert images from","image-hub")}{" "}
				<a href="https://unsplash.com" 	target="_blank" className="provider">Unsplash</a>,{" "}
				<a href="https://openverse.org" target="_blank" className="provider">Openverse</a>,{" "}
				<a href="https://pixabay.com" 	target="_blank" className="provider">Pixabay</a>,{" "}
				<a href="https://giphy.com" 	target="_blank" className="provider">Giphy</a>,{" "}
				<a href="https://pexels.com" 	target="_blank" className="provider">Pexels</a>{" "}
				{__(
					" directly in WordPress. No need to visit external websites—find, preview, and",
				)}
			</p>
			<p style={{ marginTop: 0 }} className="image-hub-text-under-logo">
				{__(
					"download images straight from the media library or editor.",
				)}
			</p>
		</div>
	);
};
